module.exports = __webpack_public_path__ + "img/logo-so-fit.321588dd.svg";